// Account Dashboard Constants

// URL Parameters
export const URL_PARAMS = {
  THANK_YOU: 'ThankYou',
} as const;

// Query Parameter Keys
export const QUERY_PARAMS = {
  THANK_YOU: URL_PARAMS.THANK_YOU,
} as const;
